import PropTypes from "prop-types";
import * as React from "react";
import { previewBackground } from "../../domain/shopImageEditor";
import css from "./CropStep.module.css";

export default function CropPreview({ item, area, caption, round = false }) {
  return (
    <figure className={css.preview}>
      <span
        aria-hidden="true"
        className={round ? css.circlePreview : css.cardPreview}
        style={{
          backgroundImage: `url("${item.dataUrl}")`,
          ...previewBackground(area, item.imageSize),
        }}
      />
      <figcaption className={css.caption}>{caption}</figcaption>
    </figure>
  );
}

CropPreview.propTypes = {
  item: PropTypes.shape({
    dataUrl: PropTypes.string.isRequired,
    imageSize: PropTypes.object.isRequired,
  }).isRequired,
  area: PropTypes.object.isRequired,
  caption: PropTypes.string.isRequired,
  round: PropTypes.bool,
};
